import useAuthenticate from "../customHooks/authenticate";

const Infohub = () => {
  useAuthenticate();
  return (
    <div
      className="flex justify-center items-start bg-gray-100 overflow-hidden"
      style={{ height: "90vh" }}
    >
      <iframe
        src="https://www.arcgis.com/apps/dashboards/88e0fcf393e5445bb0cca44fde3c16dd"
        title="Infohub Dashboard"
        className="w-full"
        style={{
          height: "110vh", // Making the iframe taller than its container
          transform: "translateY(-75px)", // Moves the iframe content upward, hiding the top part
        }}
      ></iframe>
    </div>
  );
};

export default Infohub;
